import Titre from '../components/Titre.js'
import PresentationHome from "../components/PresentationHome";

function Home() {
    return (
        <div className="container">
            <Titre/>
            <PresentationHome/>
        </div>
    )
}

export default Home